export const accountMenuItems = [
    {
        text: "TÀI KHOẢN",
        key: "Tai-khoan",
        path: "/Ca-nhan/Tai-khoan",
        submenuItems: [
            {
                text: "Hồ sơ",
                key: "Ho-so",
                path: "/Ca-nhan/Tai-khoan/Ho-so",
            },
            {
                text: "Địa chỉ",
                key: "Dia-chi",
                path: "/Ca-nhan/Tai-khoan/Dia-chi",
            },
            {
                text: "Chỉ số cơ thể",
                key: "Chi-so-co-the",
                path: "/Ca-nhan/Tai-khoan/Chi-so-co-the",
            },
            {
                text: "Đổi mật khẩu",
                key: "Doi-mat-khau",
                path: "/Ca-nhan/Tai-khoan/Doi-mat-khau",
            },
        ],
    },
    {
        text: "ĐƠN MUA",
        key: "Don-mua",
        path: "/Ca-nhan/Don-mua",
    },
    {
        text: "ĐIỂM THƯỞNG",
        key: "Diem-thuong",
        path: "/Ca-nhan/Diem-thuong",
    },
    {
        text: "DANH SÁCH QUAN TÂM",
        key: "Danh-sach-quan-tam",
        path: "/Ca-nhan/Danh-sach-quan-tam",
    },
    // {
    //     text: "THÔNG BÁO",
    //     key: "Thong-bao",
    //     path: "/Ca-nhan/Thong-bao",
    // },
    {
        text: "ĐĂNG XUẤT",
        key: "Dang-xuat",
        path: "Ca-nhan/Dang-xuat",
    },
]